import { LookupsResourcesAPI } from 'ducks/types/api-types';
import { splitJobFilterName } from 'utils/job';
import { v4 as uuidv4 } from 'uuid';

export const normalizeJobStates = (job_states: LookupsResourcesAPI[]) =>
  job_states.map((state) => ({
    job_filter_name: splitJobFilterName(state.value),
    job_state_name: state.value,
    job_state_id: state.key,
    uuid: uuidv4(),
  }));
